import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import FormInput from '../../../../commonComponents/forms/FormInput';
import DateRange from '../../../../commonComponents/forms/inputs/DateRange';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';
import ConfigsContext from '../../../../contextProviders/ConfigsContext';
import translate from '../../../../commonComponents/translate';

function CareerFilters(props) {
  const { loggedUser } = useContext(LoggedUserContext);
  const { organization } = useContext(ConfigsContext);
  const { directSelling } = organization;
  const { _id: loggedUserId } = loggedUser;
  const { t, filters, onFilterChange, onDateChange = [] } = props;
  const { user, startDate, endDate } = filters;

  const inputProps = useCallback(
    field => {
      switch (field) {
        case 'user':
          return {
            allowClear: true,
            url: '/user/table/network/list',
            filterUrl: '/user/table/network/list',
          };
        default:
          return {
            items: [],
          };
      }
    },
    [loggedUserId],
  );

  const dateRanges = {
    [t('dateRange_thisMonth')]: [
      moment().utc().startOf('month').valueOf(),
      moment().utc().endOf('day').valueOf(),
    ],
    [t('dateRange_lastMonth')]: [
      moment().utc().subtract(1, 'months').startOf('month'),
      moment().utc().subtract(1, 'months').endOf('month'),
    ],
    [t('dateRange_twoMonthsAgo')]: [
      moment().utc().subtract(2, 'months').startOf('month'),
      moment().utc().subtract(2, 'months').endOf('month'),
    ],
    [t('dateRange_threeMonthsAgo')]: [
      moment().utc().subtract(3, 'months').startOf('month'),
      moment().utc().subtract(3, 'months').endOf('month'),
    ],
    [t('dateRange_fourMonthsAgo')]: [
      moment().utc().subtract(4, 'months').startOf('month'),
      moment().utc().subtract(4, 'months').endOf('month'),
    ],
  };

  return (
    <div className="filters-wrapper">
      <div className="career-filter-container">
        <FormInput
          id="user"
          value={user}
          name="user"
          disabled={false}
          placeholder={t('user')}
          type="users"
          onChange={onFilterChange('user')}
          inputProps={inputProps('user')}
        />
      </div>
      <div className="career-filter-container">
        <DateRange
          directSellingSettings={directSelling}
          id="dateRange"
          placeholder={t('report.arcova.searchDate')}
          startDate={startDate}
          endDate={endDate}
          onChange={({ startDate: sDate, endDate: eDate }) =>
            onDateChange(sDate, eDate)
          }
          onClear={() => onDateChange(null, null)}
          customRanges={dateRanges}
        />
      </div>
    </div>
  );
}

CareerFilters.propTypes = {
  t: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    user: PropTypes.string,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
  }).isRequired,
};

export default translate(CareerFilters);
